// @ts-nocheck
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Intent } from '@blueprintjs/core';
import { compose } from '@/utils';
import { DataTable, TableSkeletonRows, AppToaster } from '@/components';
import { useLogoLibraryContext } from './LogoLibraryProvider';
import { ActionMenuList, useLogoLibraryColumns } from './components';
import withDialogActions from '@/containers/Dialog/withDialogActions';
import withAlertActions from '@/containers/Alert/withAlertActions';
import { DialogsName } from '@/constants/dialogs';
import { useDeleteLogoLibrary } from '@/hooks/query/logoLibrary';
import { useDeleteAttachment } from '@/hooks/query/attachments';
import t from '@/store/types';
import { useDispatch } from 'react-redux';

function LogoLibraryDataTable({ openDialog, openAlert }) {
  const { logos, isLogosLoading } = useLogoLibraryContext();
  const columns = useLogoLibraryColumns();
  const { mutate: deleteLogo } = useDeleteLogoLibrary({});
  const { mutate: deleteAttachment } = useDeleteAttachment({});
  const dispatch = useDispatch();

  const handleEdit = useCallback(
    (logo) => openDialog(DialogsName.LogoLibraryForm, { action: 'edit', logo }),
    [openDialog],
  );

  const handleDeleteLogo = useCallback(
    ({ id, logo: logoKey }) => {
      dispatch({
        type: t.OPEN_ALERT,
        name: 'item-data-delete',
        payload: {
          message: 'Once you delete this logo, you will not be able to restore it.',
          onConfirm: () => {
            deleteLogo(id, {
              onSuccess: () => {
                if (logoKey) deleteAttachment(logoKey);
                AppToaster.show({
                  message: 'Logo deleted successfully.',
                  intent: Intent.SUCCESS,
                });
              },
              onError: () => {
                AppToaster.show({
                  message: 'Failed to delete logo.',
                  intent: Intent.DANGER,
                });
              },
            });
          },
        },
      });
    },
    [deleteLogo, deleteAttachment, dispatch],
  );

  return (
    <StyledDataTable
      columns={columns}
      data={logos}
      loading={isLogosLoading}
      progressBarLoading={isLogosLoading}
      TableLoadingRenderer={TableSkeletonRows}
      ContextMenu={ActionMenuList}
      noInitialFetch={true}
      payload={{ onEdit: handleEdit, onDelete: handleDeleteLogo }}
      rowContextMenu={ActionMenuList}
    />
  );
}

export default compose(withDialogActions, withAlertActions)(LogoLibraryDataTable);

const StyledDataTable = styled(DataTable)`
  .table .th,
  .table .td {
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;
  }
`;
